import { useEffect } from 'react'

import { useStickyBannerContext } from '../../../../standard-shop-layout'

export const useHideStickyBannerWhenStickyBuyBoxIsVisible = (
  shouldShowStickyBuyBox: boolean,
): void => {
  const stickyBannerContext = useStickyBannerContext()

  useEffect(() => {
    const stickyBuyBox = document.querySelector(
      '[data-clientside-hook="stickyBuyBox"]',
    )

    let shouldHideSticky =
      stickyBuyBox instanceof HTMLElement && shouldShowStickyBuyBox

    if (!shouldHideSticky) {
      // eslint-disable-next-line unicorn/try-complexity -- don't reference, refactor if touched
      try {
        if (localStorage.getItem('nl-banner')) {
          shouldHideSticky = true
        }
      } catch {
        shouldHideSticky = false
      }
    }

    // this one will hide the banner added by external script, known case AT tenant PDP added by GTM.
    const stickyBanner = document.querySelector(
      '[data-clientside-hook~="stickyBanner"]:not([data-controlled-by-react="true"])',
    )

    /**
     * This one will hide {@link StickyBanner} that is controlled by us/react
     */
    stickyBannerContext?.setForceHidden(shouldHideSticky)

    if (!(stickyBanner instanceof HTMLElement)) {
      return
    }

    stickyBanner.style.display = shouldHideSticky ? 'none' : 'block'
  }, [shouldShowStickyBuyBox, stickyBannerContext])

  return undefined
}
